module.exports = __webpack_public_path__ + "static/media/back-arrow.e048988e.svg";